"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Wrapper around the localStorage to parse / stringify during getItem and setItem
 */
ngModule.factory("$localStorage", function ($window, NonPersistentStorage) {
  var storage = isStorageSupported($window, "localStorage") ? $window.localStorage : new NonPersistentStorage();
  return {
    getItem: function getItem(key) {
      return JSON.parse(storage.getItem(key));
    },
    setItem: function setItem(key, value) {
      return storage.setItem(key, JSON.stringify(value));
    },
    removeItem: function removeItem(key) {
      return storage.removeItem(key);
    }
  };
});
function isStorageSupported(window, storeName) {
  try {
    var testKey = 'test-storage',
      storage = window[storeName];
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}

/**
 * Naive localStorage / sessionStorage shim
 * ( mainly for safari private browsing mode )
 */
ngModule.factory("NonPersistentStorage", function () {
  return function NonPersistentStorage() {
    var self = this,
      data = {};
    var recomputeLength = function recomputeLength() {
      self.length = _.keys(data);
    };
    return {
      clear: function clear() {
        data = {};
        recomputeLength();
      },
      getItem: function getItem(key) {
        return _.has(data, key) ? JSON.parse(data[key]) : null;
      },
      key: function key(i) {
        var keys = _.keys(data);
        if (i < keys.length) {
          return keys[i];
        }
        return null;
      },
      removeItem: function removeItem(key) {
        delete data[key];
        recomputeLength();
      },
      setItem: function setItem(key, value) {
        data[key] = JSON.stringify(value);
        recomputeLength();
      },
      length: 0
    };
  };
});

//////////////


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/$localStorage.js
// module id = 2740
// module chunks = 13